import '../../App.css';
import svg16 from '../../img/svg/icn_16.svg';
import svg19 from '../../img/svg/icn_19.svg';
import svg17 from '../../img/svg/icn_17.svg';
import svg18 from '../../img/svg/icn_18.svg';
import svg20 from '../../img/svg/icn_20.svg';
import svg7 from '../../img/svg/icn_7.svg';
import svg6 from '../../img/svg/icn_6.svg';
import svg10 from '../../img/svg/icn_10.svg';
import svg5 from '../../img/svg/icn_5.svg';
import svg8 from '../../img/svg/icn_8.svg';
import svg9 from '../../img/svg/icn_9.svg';
import { ReactComponent as Logo } from '../../img/svg/icn_19.svg';
import { useEffect, useState } from 'react';
import Loader from '../loader/loader';

const cargarCarreras = (modalidad) => {
 const CarreraArray = [];
 modalidad.forEach((element) => {
  CarreraArray.push(element.carreras);
 });
 return CarreraArray;
};

const icons = [
 { icon: svg16, id: 8 },
 { icon: svg19, id: 10 },
 { icon: svg17, id: 23 },
 { icon: svg18, id: 33 },
 { icon: svg20, id: 35 },
 { icon: svg7, id: 37 },
 { icon: svg6, id: 40 },
 { icon: svg10, id: 43 },
 { icon: svg5, id: 96 },
 { icon: svg8, id: 60 },
 { icon: svg9, id: 79 },
];

function Step3({ setPage, page, carrera, setCarrera, validation, carreras, loader }) {
 const [styleActiveAll, setActiveAll] = useState('active');
 const [styleActiveOnline, setActiveOnline] = useState('');
 const [styleActive, setActive] = useState('');
 const [array_carreras, setArray] = useState([]);

 useEffect(() => {
  setArray(cargarCarreras(carreras));
 }, []);

 const setStyles = (type) => {
  switch (type) {
   case '':
    setActive('active');
    setActiveAll('');
    setActiveOnline('');

    break;
   case 'all':
    setActive('');
    setActiveAll('active');
    setActiveOnline('');

    break;
   case 'online':
    setActive('');
    setActiveAll('');
    setActiveOnline('active');

    break;

   default:
    break;
  }
 };

 const presencial = 'Presencial';
 const semipresencial = 'Semipresencial';

 return (
  <section class="step style--1">
   <div class="in">
    <header class="marquee">
     <div class="in">
      <div class="maxwidth">
       <div class="logo gone"></div>
       <div class="ttl">
        <span class="num fonty">{page + 1}</span>
        <h2>Elige tu carrera</h2>
       </div>
       <div class="air gone"></div>
      </div>
     </div>
    </header>
    <main class="no--flex">
     <div class="maxwidth2">
      <div class="ttl text--center big steps-title titular">
       ¿Qué carrera <b className="bold_letter">te gustaría estudiar?</b>
      </div>
     </div>
     <div class="maxwidth padded--left padded--right">
      <nav class="filter">
       <ul data-help="Lorem ipsum dolor sit amet.">
        <li class={styleActive === '' ? 'active' : ''}>
         <button
          id="Todos"
          name="Todos"
          onClick={() => {
           setArray(cargarCarreras(carreras));
           setStyles('all'); //5 presencial 6 semi
          }}>
          Todas
         </button>
        </li>
        {carreras.map((Element) => {
         return (
          <>
           <li class={styleActive === Element.nombre_modalidad ? 'active' : ''}>
            <button
             id="Todos"
             name="Todos"
             onClick={() => {
              setArray(cargarCarreras([Element]));
              setActive(Element.nombre_modalidad);
             }}>
             {Element.nombre_modalidad}
            </button>
           </li>
          </>
         );
        })}
       </ul>
      </nav>
      <div class="filterable required empty">
       {loader ? (
        <>
         <h1 className="loader-2">Cargando..</h1>
        </>
       ) : (
        <>
         <ul>
          {array_carreras.map((element) => {
           return (
            <>
             {element.map((c) => {
              return (
               <>
                <li
                 class="submit"
                 onClick={() => {
                  //setCarrera(c.id)
                  setCarrera(c);
                  setPage((currentPage) => currentPage + 1);
                 }}>
                 <button
                  className="red_button"
                  id={c.id_carrera}
                  name={c.id_carrera}>
                  <span className={carrera.id_carrera === c.id_carrera ? 'icn icn_ selected_icon' : 'icn icn_'}>
                   <span className={carrera.id_carrera === c.id_carrera ? 'selected' : ''}>
                    {c.carrera.url_icono_carrera === null ? (
                     <>
                      <Logo
                       alt=""
                       fill={carrera.id_carrera === c.id_carrera ? 'white' : '#e23038'}
                      />
                     </>
                    ) : (
                     <>
                      <img
                       src={c.carrera.url_icono_carrera}
                       alt=""
                       className={carrera.id_carrera === c.id_carrera ? 'sgv_icon_selected' : 'svg_icon'}
                      />
                     </>
                    )}
                   </span>
                  </span>
                  <span className={carrera.id_carrera === c.id_carrera ? 'name selected_name' : 'name'}>{c.carrera.nombre_carrera}</span>
                 </button>
                </li>
               </>
              );
             })}
            </>
           );
          })}
         </ul>
        </>
       )}
      </div>
     </div>
    </main>
   </div>
  </section>
 );
}

export default Step3;
